import DynamicList from '@/client/components/DynamicList'
import DataListModel from '@client/models/inDataList'

type EditDataListProps = { tab: any }

export default function EditDataList({ tab }: EditDataListProps) {
    const dataList = new DataListModel()
    const getArgs = (args: any) => {
        return args
    }
    const waitCondition = (args: any) => {
        return args?.dataList
    }

    return <DynamicList
        tab={tab}
        list={dataList.readDataList}
        getArgs={getArgs}
        waitCondition={waitCondition}
    />
}